import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { IEopReportSectionDetailDTO } from './IEopReportSectionDetailDTO';

@JsonObject()
export class EopReportSectionDetailCountAmountDTO implements IEopReportSectionDetailDTO {
  @JsonProperty('DA')
  public amount: number;

  @JsonProperty('DB')
  public count: number;

  @JsonProperty('DC')
  public description: string;
}
